import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const PrivateRoute = ({ isAuthenticated, isLanguage, children }) => {
  return (isAuthenticated && isLanguage) ? children : !isAuthenticated ? <Navigate to="/login" /> : null;
};

export default PrivateRoute;
